<template>
  <div class="rdo-wrap" :class="[{'hide-label': hideLabel}, customClass]">
    <input
      type="radio"
      :id="inputId"
      :name="name"
      class="rdo-hidden"
      :checked="modelValue === value"
      :disabled="disabled"
      @change="handleRdoChange"
    />
    <label v-if="label" :for="inputId" :class="['inp-radio', {'a11y-blind': hideLabel}, labelClass]">{{ label }}</label>
  </div>
</template>

<script setup lang="ts">
import { useId } from 'vue'

const inputId = useId()

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  hideLabel: {
    type: Boolean,
    default: false
  },
  labelClass: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  },
  checked: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  radioLabel: {
    type: String,
    default: ''
  },
  value: {
    type: [String, Number],
    required: false,
    default: ''
  },
  customClass: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue']);

const handleRdoChange = (e: Event) => {
  const target =  e.target as HTMLInputElement;
  const newValue = target.checked ? props.value : '';

  emit('update:modelValue', newValue);
}
</script>

<style lang="scss" scoped>
</style>